export class ParticipantStateModel {
  participants: Participant[];
  notifications: Notification[];
}

export class ParticipantList {
  participants: Participant[];
}

export class ParticipantGroup {
  id: string;
  names: string[];
  expanded: boolean;
  participants: Participant[];
  productCount: number;
  total: number;
  paymentTotal: number;
  paymentCount: number;
  profitTotal?: number;
  groupContainsPaymentRecipients?: boolean;
  hasPayments?: boolean;
  notifications?: Notification[];
  deliveryState?: DeliveryStates;
  activityShared: boolean;
}

export enum DeliveryStates {
  notApplicable = 0,
  notDelivered = 1,
  partlyDelivered = 2,
  allDelivered = 3,
}

export class Participant {
  id: string;
  name: string;
  email: string;
  mobile: string;
  source: ParticipantSource;
  tags: string[];
  created: Date;
  productCount: number;
  total: number;
  paymentTotal: number;
  profitTotal?: number;
  paymentRecipients: PaymentRecipient[];
  group: string;
  activityLinkQRCode: string;
  activityLink: string;
  products: ParticipantProduct[];
  payments: Payment[];
  metadata: Record<string, string | string[]>[] | Metadata[];
  integrationData: Record<string, unknown>[];
  deliveryState?: DeliveryStates;
  parentParticipant?: ParentParticipant;
  swishRecipient?: string;
  activityShared?: boolean;
}

export enum ParticipantSource {
  member = 0,
  manual = 1,
  registration = 2,
}

export class Metadata {
  text: string;
  important: boolean;
}

export class Notification {
  id: string;
  group: string;
  type: string;
  emailType?: number;
  smsType?: number;
  subject: string;
  recipient: string;
  errorMessage?: Date;
  requested: Date;
  processed?: Date;
  deferred?: Date;
  delivered?: Date;
  opened?: Date;
  clicked?: Date;
  dropped?: Date;
  bounced?: Date;
  spamReport?: Date;

  static fixDates(item: Notification) {
    if (item.requested) {
      item.requested = new Date(item.requested);
    }

    if (item.processed) {
      item.processed = new Date(item.processed);
    }

    if (item.deferred) {
      item.deferred = new Date(item.deferred);
    }

    if (item.delivered) {
      item.delivered = new Date(item.delivered);
    }

    if (item.opened) {
      item.opened = new Date(item.opened);
    }

    if (item.clicked) {
      item.clicked = new Date(item.clicked);
    }

    if (item.dropped) {
      item.dropped = new Date(item.dropped);
    }

    if (item.bounced) {
      item.bounced = new Date(item.bounced);
    }

    if (item.spamReport) {
      item.spamReport = new Date(item.spamReport);
    }
  }
}

export class Payment {
  id: string;
  timestamp: Date;
  amount: number;
  source: string;
  text: string;
  payerName: string;
  reference: string;
  verificationWarnings?: string[];
  verified?: Date;
  verifiedBy?: string;
}

export class ParticipantProduct {
  id: string;
  productReferenceId?: string;
  externalReferenceId?: string;
  amount: number;
  profit?: number;
  title: string;
  quantity: number;
  options: string[];
  timestamp: Date;
  comment: string;
  createdBy: string;
  updatedBy: string;
  isLocked: boolean;
  deliveryState?: ParticipantProductDeliveryState;
  isSubParticipantDebt: boolean;
}

export class ParticipantProductDeliveryState {
  delivered?: Date;
  deliveredBy?: string;
  recentlyDelivered?: boolean;
}

export class ParentParticipant {
  id: string;
  name: string;
  email: string;
}

export class PaymentRecipient {
  id: string;
  name: string;
  email: string;
  mobile: string;
}
